$(document).ready(function(e) { 
  // new code by zonex 2015-05-22 
  var cookie_enable=parseInt($("#hidcookie").val());
 // end new code by zonex 2015-05-22 
  $(".iteam-count").text(0); 
  $("button").attr("disabled", false);
    
    var variantPrice, variantId;
  	var unittot = 0;
  
    /* comment this code by zonex (no any use ) 2015-05-20 */
   /* $('.region.USA').each(function(index,product){
      $(this).addClass("show"); 
      variantPrice = $(this).find('.variant_info').attr('data-price');
      variantId = $(this).find('.variant_info').attr('data-variant-id');
      if (parseInt($(this).find('.variant_info').attr('data-stock-count')) <= 0) {
        $(this).parent().addClass("out-of-stock");
        $(this).parent().prepend('<a class="out-of-stock fancybox fancybox.iframe" href="/pages/mailbox"> <div class="out-of-text">PRE-ORDER<br>Click here to learn more</div> </a> ');        
      }
      $(this).parent().find('.price span').text(variantPrice);   
      //$(".out-of-stock button").attr("disabled", true);
    });
    */
    /* End comment this code by zonex (no any use ) */
  $(".fi-minus").click(function(){ 
      
      var productId = $(this).parent().parent().find('.show  .variant_info').attr('data-variant-id');
      var iteamCount = parseInt($(this).parent().find(".iteam-count").text());
      if (!(iteamCount <= 0)) {     
        $(this).parent().find(".iteam-count").text(iteamCount - 1 );
        unittot=unittot-1;
      };
      updateTotal();
  }); 
  
  $(".fi-plus").click(function(){ 
    
    var productId = $(this).parent().parent().find('.show  .variant_info').attr('data-variant-id');
    var iteamCount = parseInt($(this).parent().find(".iteam-count").text());
    if (!(iteamCount > 1000)) {     
        $(this).parent().find(".iteam-count").text(iteamCount + 1 );
      unittot=unittot+1;
    };
    updateTotal();
  }); 
  
  
  
 /* new code by zonex  2015-05-20 and 2015-05-22 */
  $('#kitchencollection .kitchensafe-button').click(function(event){
    $('#kitchencollection .kitchensafe-button').removeClass("active"); 
    $(this).addClass("active");
    var collection = $(this).attr('data-region');
    
    /** Edited by zonex 2015-09-04 **/
    $("#productblock").attr("class", "");
    $("#productblock").addClass(collection);
    /** end Edited by zonex 2015-09-04 **/
    
    
    if(cookie_enable ==1){
    createCookie("collection", collection, 365);
    }
    /* Start modified by m9dev  2019-06-27*/
    $('#kitchennav .active').trigger('click',"2");
	/* End modified by m9dev  2019-06-27*/
  });
  
   /* for original code check file = purchase.original.js */
   /* End new code by zonex  2015-05-20*/
   /* Edited code by zonex  2015-05-21 and 2015-05-22 and 2015-05-25 and 2015-05-27 */
   /* Edited by m9dev  2019-06-27*/
   $('#kitchennav .kitchensafe-button').click(function(event,countrybuttonopt=1){ 
    
    
    console.log(countrybuttonopt);
    
    if(countrybuttonopt=="2"){ 
    
    }else{
      $("#totalCout").html('0');
      $('#productblock .count-product .iteam-count').text(0);
      unittot=0;
    }
   var collectionType = $('#kitchencollection .active').attr("data-region"); 
    $('#kitchennav .kitchensafe-button').removeClass("active"); 
    $(this).addClass("active");
   var country = $(this).attr('data-region');
    //new add 2015-06-17
   var location = $(this).attr('data-location');
    //end new add 2015-06-17
     if(cookie_enable ==1){
    createCookie("country", country, 365);
     }
    $('.product-note').hide();
    //edit 2015-06-17
    $('.product-note.' + location).show();
    //end edit 2015-06-17
    $('#productblock .product-detail').hide();
    $('#productblock .'+collectionType).each(function(index,product){
    if($(this).hasClass(country))
      {
       $(this).show(); 
       $('.'+collectionType+' .region.'+country).each(function(index,product){ 
       $(this).addClass("show"); 
       variantPrice = $(this).find('.variant_info').attr('data-price');
       variantId = $(this).find('.variant_info').attr('data-variant-id');
        if (parseInt($(this).find('.variant_info').attr('data-stock-count')) <= 0) {
         if(!$(this).parent().hasClass("out-of-stock"))
         {
         $(this).parent().addClass("out-of-stock");
         $(this).parent().prepend('<a class="out-of-stock fancybox.iframe" href="https://www.thekitchensafe.com/collections/pre-order"> <div class="out-of-text">SOLD OUT<br>Click here to pre-order</div> </a> ');
           // new updated 2015-06-16
         $(this).parent().children('.count-product').children('button').attr("disabled", "disabled");  
            // end new updated 2015-06-16
         }
        }
        else
        {
          $(this).parent().removeClass("out-of-stock");
          $(this).parent().children('a.out-of-stock').remove();
           // new updated 2015-06-16
          $(this).parent().children('.count-product').children('button').removeAttr("disabled");
           // end new updated 2015-06-16
        }
      $(this).parent().find('.price span').text(variantPrice); 
         });
      }
    });
  });
   /* end edited code by zonex  2015-05-21*/

  function updateTotal(){
    
    var products = $('.show  .variant_info');
    var sum = 0.0;
    var quantity,price = 0;
    products.each(function(index,product){
      quantity = parseInt($(this).parent().parent().find(".iteam-count").text());
      price = $(this).attr('data-price-int');
      sum += price * quantity;
    });
    var amount = Shopify.formatMoney(sum).split('.');
    $("#totalCout").html(unittot);
  }
  
  var queue = [];
  
  $("#purchase").click(function (e){
   queue.length=0;
        e.preventDefault();
    /* edited by zonex  2015-05-21 and 2015-05-22*/
    var collection = $('#kitchencollection .active').attr('data-region');
    var country = $('#kitchennav .active').attr('data-region');
    
     	$('.'+collection+' .'+country+'.show  .variant_info').each(function(idx, product) {
       	/* end edited by zonex 2015-05-21 */
            var quantity = parseInt($(this).parent().parent().find(".iteam-count").text());
            if (quantity > 0) {
             // alert($(this).attr('data-variant-id')+"===="+quantity);
                queue.push({id: $(this).attr('data-variant-id'), quantity: quantity});
            }
          
        });
       
        if(queue.length) {
          	addItemsToCartandcheckout();
          } else {
            alert("You have not selected anything to purchase!");
        }
    
    });
  
  function addItemsToCartandcheckout() {
    var item = queue.pop();
    if(typeof item == 'object') {
        Shopify.addItem(item.id, item.quantity, addItemsToCartandcheckout);
    } else {
      //window.parent.location.href="/checkout";
     // alert('cart');
      window.parent.location.href="/cart";
    }
  } 
  
  /**** New Code by zonex 2015-05-21 and 2015-05-22 */////////////////////////
   if(cookie_enable ==1){
  var oldcollection=readCookie('collection');
  var oldcountry=readCookie('country');
  //alert("coll="+oldcollection+"====count="+oldcountry);
  if(oldcollection != null)
  {
    $('#kitchencollection .kitchensafe-button').removeClass("active"); 
    $("#kitchencollection").find("[data-region='" + oldcollection + "']").addClass("active");
  }
  if(oldcountry != null)
  {
    $('#kitchennav .kitchensafe-button').removeClass("active"); 
    $("#kitchennav").find("[data-region='" + oldcountry + "']").addClass("active");
  }
   }
  $('#kitchencollection .active').trigger('click');
  
  /************************End New Code by zonex 2015-05-21 */////////////////////////
  
});
/* New Code by zonex 2015-05-21*/
function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
/* end New Code by zonex 2015-05-21*/